import { render, staticRenderFns } from "./ObjectDisplaying.vue?vue&type=template&id=c77f3234&scoped=true"
import script from "./ObjectDisplaying.vue?vue&type=script&lang=ts"
export * from "./ObjectDisplaying.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77f3234",
  null
  
)

export default component.exports